import { Dialog } from '@mui/material'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)
import { useEffect, useState } from 'react'
import Calendar from 'react-calendar'
import { LoadingSpinner } from 'src/consumer/components/Loaders'
import { getTimezoneOffset } from 'src/consumer/helpers/utilFunctions'
import { getTimeZoneOptionsWithValueAsTimezoneOffset } from 'src/mentor/components/MentorAvailabilityPage/MentorAvailabilityPageStyles'
import './BPBookingCalendar.css'
import {
  AddEmployeesDialogPaper,
  BPAlreadyBookedEventHeading,
  BPAlreadyBookedEventHighlight,
  BPAlreadyBookedEventSecondary,
  BPAvailableEventHighlight,
  BPAvailableEventItem,
  BPAvailableEventSecondary,
  BPBookedEventItem,
  BPBookedEventsHeading,
  BPBookedEventsParent,
  BPBookingDialogPaper,
  BPCalendarContainer,
  BPCalendarDateHeading,
  BPCalendarSeparator,
  BPEventCalendarParent,
  BPEventsWidgetParent,
  StyledWebinarSelectTimeZone,
} from './BookingWidgetStyles'
import {
  checkIfBookingIsAvailable,
  checkIfTwoDatesAreEqual,
  fetchAlreadyBookedWebinars,
  fetchAvalableBookings,
} from './booking-utils'
import AddEmployeesToWebinarDialog from './components/AddEmployeesToWebinarDialog'
import BookingWebinarPaymentPage from './components/BookingWebinarPaymentPage'
import { useNavigate } from 'react-router-dom'

export const BusinessEventsWidget = () => {
  const [selectedDateValue, setSelectedDateValue] = useState()
  const [bookingsVisibleMonthAnyDate, setBookingsVisibleMonthAnyDate] = useState(new Date())
  const [availableWebinars, setAvailableWebinars] = useState([])
  const [alreadyBookedWebinars, setAlreadyBookedWebinars] = useState([])
  const [loading, setLoading] = useState(false)
  const [showBookingDialog, setShowBookingDialog] = useState(false)
  const [webinarToBook, setWebinarToBook] = useState()
  const [selectedTimeZone, setSelectedTimeZone] = useState(encodeURIComponent(getTimezoneOffset()))

  const decodedTimeZone = decodeURIComponent(selectedTimeZone)

  function selectAWebinarToBook(eventDetails) {
    setWebinarToBook(eventDetails)
    setShowBookingDialog(true)
  }

  async function getAvailableWebinars() {
    const webinars = await fetchAvalableBookings()
    if (webinars) {
      setAvailableWebinars(webinars)
    }
  }
  async function getAllBookedWebinars() {
    const webinars = await fetchAlreadyBookedWebinars()
    if (webinars) {
      setAlreadyBookedWebinars(webinars)
    }
  }
  function closeBookingDialog() {
    setShowBookingDialog(false)
  }

  async function Setup() {
    setLoading(true)
    getAvailableWebinars()
    getAllBookedWebinars()
    setSelectedDateValue(new Date())
    setLoading(false)
  }

  useEffect(() => {
    Setup()
  }, [])
  useEffect(() => {
    console.log({ selectedDateValue })
  }, [selectedDateValue])

  return loading ? (
    <LoadingSpinner bgColor="#F5F5F599" dark />
  ) : (
    <BPEventsWidgetParent>
      <BusinessEventBookingCalendarComponent
        selectedDateValue={selectedDateValue}
        availableWebinars={availableWebinars}
        setSelectedDateValue={setSelectedDateValue}
        setBookingsVisibleMonthAnyDate={setBookingsVisibleMonthAnyDate}
        selectAWebinarToBook={selectAWebinarToBook}
        setSelectedTimeZone={setSelectedTimeZone}
        selectedTimeZone={decodedTimeZone}
      />
      <BusinessBookedEventsComponent
        alreadyBookedWebinars={alreadyBookedWebinars}
        bookingsVisibleMonthAnyDate={bookingsVisibleMonthAnyDate}
        selectedTimeZone={decodedTimeZone}
      />
      <Dialog
        open={showBookingDialog}
        onClose={closeBookingDialog}
        PaperComponent={BPBookingDialogPaper}
        sx={{ backdropFilter: 'blur(5px)' }}
      >
        <BookingWebinarPaymentPage
          allEvents={availableWebinars}
          eventDetails={webinarToBook}
          closeDialog={closeBookingDialog}
        />
      </Dialog>
    </BPEventsWidgetParent>
  )
}

export function BusinessEventBookingCalendarComponent({
  selectedDateValue,
  availableWebinars,
  setSelectedDateValue,
  setBookingsVisibleMonthAnyDate,
  selectAWebinarToBook,
  selectedTimeZone,
  setSelectedTimeZone,
}) {
  const dateToday = new Date()
  const maxDate = new Date(dateToday)
  maxDate?.setMonth(dateToday?.getMonth() + 2) // setting max date of calendar 2 monts ahead of current date

  function tileDisabled({ date, view }) {
    // Disable tiles in month view only
    // if (view === 'month') {
    //     // Check if a date React-Calendar wants to check is on the list of disabled dates
    //     // return disabledDates.find(dDate => isSameDay(dDate, date));

    //     // only checking if professional available, not checking exempt dates

    //     const elementFoundTimeSlot = availableTimeSlots?.find(item => item?.date === dayjs(date)?.format("YYYY-MM-DD"));
    //     if (elementFoundTimeSlot?.availableTimeSlots && elementFoundTimeSlot?.availableTimeSlots?.length > 0) {
    //         return false;
    //     }

    //     return true;
    // }
    const currentDate = dayjs(date)
    if (view === 'month') {
      const dateIsValid = availableWebinars?.some((webinar) =>
        checkIfBookingIsAvailable(webinar, currentDate, selectedTimeZone),
      )
      return !dateIsValid
    }
    return false
  } // disabling unavailable days

  function onChangeDate(nextValue) {
    setSelectedDateValue(nextValue)
  } // change date function for calendar

  // async function setCalendarData(dateToLookFor, userZoneOffset, mentorZoneOffset) {

  //     setCalendarLoading(true);
  //     const tempDatesOfMonthArray = [];
  //     const year = dayjs(dateToLookFor, 'YYYY-MM-DD').year();
  //     const month = dayjs(dateToLookFor, 'YYYY-MM-DD').month();
  //     const startDate = dayjs({ year, month }).startOf('month').format('YYYY-MM-DD');
  //     const endDate = dayjs({ year, month }).endOf('month').format('YYYY-MM-DD');
  //     let currentDate = dayjs(startDate);
  //     while (currentDate?.isSameOrBefore(endDate, 'day')) {
  //         tempDatesOfMonthArray.push(currentDate.format('YYYY-MM-DD'));
  //         currentDate.add(1, 'day');
  //     }
  //     //made temp array with dates like YYYY-MM-DD

  //     const datesOfMonthInUserTimezone = [];
  //     const datesOfMonthInUTC = [];
  //     const datesOfMonthInMentorZone = [];

  //     tempDatesOfMonthArray?.forEach((item) => {
  //         datesOfMonthInUserTimezone?.push({
  //             date: item,
  //             dayStart: dayjs(item)?.format(`YYYY-MM-DDTHH:mm:ss[${decodeURIComponent(userZoneOffset)}]`),
  //             dayEnd: dayjs(item)?.endOf('day')?.format(`YYYY-MM-DDTHH:mm:ss[${decodeURIComponent(userZoneOffset)}]`)
  //         });
  //     }) // getting datesOfMonthInUserTimezone

  //     datesOfMonthInUserTimezone?.forEach((item) => {
  //         datesOfMonthInUTC?.push({
  //             date: item?.date,
  //             dayStart: dayjs?.utc(item?.dayStart)?.format('YYYY-MM-DDTHH:mm:ss[Z]'),
  //             dayEnd: dayjs?.utc(item?.dayEnd)?.format('YYYY-MM-DDTHH:mm:ss[Z]'),
  //         });
  //     }) // getting datesOfMonthInUTC

  //     datesOfMonthInUTC?.forEach((item) => {
  //         datesOfMonthInMentorZone?.push({
  //             date: item?.date,
  //             dayStart: dayjs?.utc(item?.dayStart)?.utcOffset(decodeURIComponent(mentorZoneOffset))?.format(`YYYY-MM-DDTHH:mm:ss[${decodeURIComponent(mentorZoneOffset)}]`),
  //             dayEnd: dayjs?.utc(item?.dayEnd)?.utcOffset(decodeURIComponent(mentorZoneOffset))?.format(`YYYY-MM-DDTHH:mm:ss[${decodeURIComponent(mentorZoneOffset)}]`)
  //         });
  //     }) // getting datesOfMonthInMentorZone

  //     datesOfMonthInMentorZone?.forEach((item, index) => {
  //         if (item?.dayStart?.substring(0, 10) === item?.dayEnd?.substring(0, 10)) {
  //             const mentorDayData = scheduleOfProfessional?.weeklyHourMap?.[dayjs(item?.dayStart?.substring(0, 10))?.format('dddd')?.toLowerCase()];
  //             if (mentorDayData && mentorDayData?.available) {
  //                 const availableSlotsArray = [];
  //                 mentorDayData?.slotList?.forEach((slotItem) => {
  //                     availableSlotsArray?.push(
  //                         {
  //                             startTime: item?.dayStart?.substring(0, 10) + "T" + slotItem?.startTime + decodeURIComponent(mentorZoneOffset),
  //                             endTime: item?.dayStart?.substring(0, 10) + "T" + slotItem?.endTime + decodeURIComponent(mentorZoneOffset)
  //                         }
  //                     )
  //                 })
  //                 datesOfMonthInMentorZone[index].slotsAvailable = availableSlotsArray;
  //             } else {
  //                 datesOfMonthInMentorZone[index].slotsAvailable = [];
  //             }
  //         } else {
  //             const mentorStartDayData = scheduleOfProfessional?.weeklyHourMap?.[dayjs(item?.dayStart?.substring(0, 10))?.format('dddd')?.toLowerCase()];
  //             const mentorEndDayData = scheduleOfProfessional?.weeklyHourMap?.[dayjs(item?.dayEnd?.substring(0, 10))?.format('dddd')?.toLowerCase()];
  //             const slotsTempArray = [];

  //             if (mentorStartDayData?.available) {
  //                 mentorStartDayData?.slotList?.forEach((startDayItem) => {
  //                     if ((startDayItem?.startTime > item?.dayStart?.substring(11, 19)) && (startDayItem?.endTime > item?.dayStart?.substring(11, 19))) {
  //                         slotsTempArray?.push(
  //                             {
  //                                 startTime: item?.dayStart?.substring(0, 10) + "T" + startDayItem?.startTime + item?.dayStart?.substring(19),
  //                                 endTime: item?.dayStart?.substring(0, 10) + "T" + startDayItem?.endTime + item?.dayStart?.substring(19)
  //                             }
  //                         )
  //                     }
  //                     if ((startDayItem?.startTime < item?.dayStart?.substring(11, 19)) && (startDayItem?.endTime > item?.dayStart?.substring(11, 19))) {
  //                         slotsTempArray?.push(
  //                             {
  //                                 startTime: item?.dayStart?.substring(0, 10) + "T" + item?.dayStart?.substring(11, 19) + item?.dayStart?.substring(19),
  //                                 endTime: item?.dayStart?.substring(0, 10) + "T" + startDayItem?.endTime + item?.dayStart?.substring(19)
  //                             }
  //                         )
  //                     }
  //                 })
  //             }

  //             if (mentorEndDayData?.available) {
  //                 mentorEndDayData?.slotList?.forEach((endDayItem) => {
  //                     if (endDayItem?.startTime < item?.dayEnd?.substring(11, 19) && endDayItem?.endTime < item?.dayEnd?.substring(11, 19)) {
  //                         slotsTempArray?.push(
  //                             {
  //                                 startTime: item?.dayEnd?.substring(0, 10) + "T" + endDayItem?.startTime + item?.dayEnd?.substring(19),
  //                                 endTime: item?.dayEnd?.substring(0, 10) + "T" + endDayItem?.endTime + item?.dayEnd?.substring(19)
  //                             }
  //                         )
  //                     }
  //                     if (endDayItem?.startTime < item?.dayEnd?.substring(11, 19) && endDayItem?.endTime > item?.dayEnd?.substring(11, 19)) {
  //                         slotsTempArray?.push(
  //                             {
  //                                 startTime: item?.dayEnd?.substring(0, 10) + "T" + endDayItem?.startTime + item?.dayEnd?.substring(19),
  //                                 endTime: item?.dayEnd?.substring(0, 10) + "T" + item?.dayEnd?.substring(11, 19) + item?.dayEnd?.substring(19)
  //                             }
  //                         )
  //                     }
  //                 })
  //             }

  //             datesOfMonthInMentorZone[index].slotsAvailable = slotsTempArray;
  //         }
  //     })

  //     datesOfMonthInMentorZone?.forEach((item, index) => {
  //         const slotsAvailableTemp = [];
  //         item?.slotsAvailable?.forEach((slotItem) => {
  //             slotsAvailableTemp?.push(
  //                 {
  //                     startTime: dayjs?.utc(slotItem?.startTime)?.format('YYYY-MM-DDTHH:mm:ss[Z]'),
  //                     endTime: dayjs?.utc(slotItem?.endTime)?.format('YYYY-MM-DDTHH:mm:ss[Z]')
  //                 }
  //             )
  //         })
  //         datesOfMonthInUTC[index].slotsAvailable = slotsAvailableTemp;
  //     })

  //     datesOfMonthInUTC?.forEach((item, index) => {
  //         const slotsAvailableTemp = [];
  //         item?.slotsAvailable?.forEach((slotItem) => {
  //             slotsAvailableTemp?.push(
  //                 {
  //                     startTime: dayjs?.utc(slotItem?.startTime)?.utcOffset(decodeURIComponent(userZoneOffset))?.format(`YYYY-MM-DDTHH:mm:ss[${decodeURIComponent(userZoneOffset)}]`),
  //                     endTime: dayjs?.utc(slotItem?.endTime)?.utcOffset(decodeURIComponent(userZoneOffset))?.format(`YYYY-MM-DDTHH:mm:ss[${decodeURIComponent(userZoneOffset)}]`)
  //                 }
  //             )
  //         })
  //         datesOfMonthInUserTimezone[index].slotsAvailable = slotsAvailableTemp;
  //     })

  //     // by this point, we have mentor availability in user timezone in datesOfMonthInUserTimezone
  //     // now we get from api, the unavailability

  //     const monthStartPerUtc = dayjs?.utc(datesOfMonthInUserTimezone?.[0]?.dayStart)?.format('YYYY-MM-DDTHH:mm:ss[Z]');
  //     const monthEndPerUtc = dayjs?.utc(datesOfMonthInUserTimezone?.[datesOfMonthInUserTimezone?.length - 1]?.dayEnd)?.format('YYYY-MM-DDTHH:mm:ss[Z]');

  //     const response = await getDataWithoutParams(`/api/secure/mentor/booked-slots?mentorId=${mentorId}&startTime=${monthStartPerUtc}&endTime=${monthEndPerUtc}&eventType=${eventId}`);
  //     const unavailabilitySlotsOfMonthPerUtc = response?.data || [];
  //     const unavailabilitySlotsOfMonthPerUserTime = [];

  //     unavailabilitySlotsOfMonthPerUtc?.forEach((item) => {
  //         unavailabilitySlotsOfMonthPerUserTime?.push({
  //             startTime: dayjs?.utc(item?.startTime)?.utcOffset(decodeURIComponent(userZoneOffset))?.format(`YYYY-MM-DDTHH:mm:ss[${decodeURIComponent(userZoneOffset)}]`),
  //             endTime: dayjs?.utc(item?.endTime)?.utcOffset(decodeURIComponent(userZoneOffset))?.format(`YYYY-MM-DDTHH:mm:ss[${decodeURIComponent(userZoneOffset)}]`)
  //         })
  //     }) // also adding pre and post buffer time here

  //     setUserPerspectiveCalendarData(datesOfMonthInUserTimezone);
  //     setCalendarLoading(false);

  //     await setTimeSlots(datesOfMonthInUserTimezone, unavailabilitySlotsOfMonthPerUserTime, eventDetailOfRequestedEvent);

  // }

  // async function setTimeSlots(availabilityData, nonAvailabilityData, eventDetailOfRequestedEvent) {

  //     const dateWiseTimeSlots = [];
  //     const eventDuration = eventDetailOfRequestedEvent?.preBufferMins + eventDetailOfRequestedEvent?.durationInMins + eventDetailOfRequestedEvent?.postBufferMins;

  //     availabilityData?.forEach((item) => {
  //         const daySlotsArray = [];
  //         item?.slotsAvailable?.forEach((slotTimeObject) => {
  //             let currentStartTime = dayjs(slotTimeObject?.startTime);
  //             let endTime = dayjs(slotTimeObject?.endTime)

  //             while (currentStartTime?.isSameOrBefore(endTime)) {
  //                 const slotEnd = dayjs(currentStartTime)?.add(eventDuration, 'minutes');
  //                 if (slotEnd?.isSameOrBefore(endTime)) {

  //                     let startIsBwUnavailable = false;
  //                     let endIsBwUnavailable = false;

  //                     nonAvailabilityData?.forEach((nonAvailableSlot) => {
  //                         const UnavailableTimeSlotStart = dayjs(nonAvailableSlot?.startTime)?.subtract(eventDetailOfRequestedEvent?.preBufferMins, 'minutes')
  //                         const UnavailableTimeSlotEnd = dayjs(nonAvailableSlot?.endTime)?.add(eventDetailOfRequestedEvent?.postBufferMins, 'minutes')
  //                         if (currentStartTime?.isBetween(UnavailableTimeSlotStart, UnavailableTimeSlotEnd) || currentStartTime?.isSame(UnavailableTimeSlotStart)) {
  //                             startIsBwUnavailable = true;
  //                         }
  //                         if (slotEnd?.isBetween(UnavailableTimeSlotStart, UnavailableTimeSlotEnd) || slotEnd?.isSame(UnavailableTimeSlotEnd)) {
  //                             endIsBwUnavailable = true;
  //                         }
  //                     })

  //                     if (startIsBwUnavailable === false && endIsBwUnavailable === false) {
  //                         const perUtcCurrentStart = dayjs?.utc(currentStartTime)?.format('YYYY-MM-DDTHH:mm:ss[Z]')
  //                         const perUtcSlotEnd = dayjs?.utc(slotEnd)?.format('YYYY-MM-DDTHH:mm:ss[Z]')
  //                         const perUserCurrentStart = dayjs?.utc(perUtcCurrentStart)?.utcOffset(decodeURIComponent(selectedTimeZone))?.format(`YYYY-MM-DDTHH:mm:ss[${decodeURIComponent(selectedTimeZone)}]`)
  //                         const perUserSlotEnd = dayjs?.utc(perUtcSlotEnd)?.utcOffset(decodeURIComponent(selectedTimeZone))?.format(`YYYY-MM-DDTHH:mm:ss[${decodeURIComponent(selectedTimeZone)}]`)

  //                         //perspective of user : per user

  //                         if (dayjs?.utc(perUtcCurrentStart)?.utcOffset(decodeURIComponent(selectedTimeZone))?.isAfter(dayjs()?.utcOffset(decodeURIComponent(selectedTimeZone)))) {
  //                             daySlotsArray?.push(
  //                                 {
  //                                     startTime: perUserCurrentStart,
  //                                     endTime: perUserSlotEnd
  //                                 }
  //                             )
  //                         }

  //                     }
  //                     else {
  //                         // console.log(currentStartTime?.format() + " to " + slotEnd?.format() + " is not available")
  //                     }

  //                 }
  //                 currentStartTime?.add(eventDuration, 'minutes')
  //             }

  //         })
  //         dateWiseTimeSlots?.push({ date: item?.date, availableTimeSlots: daySlotsArray })
  //     })

  //     setAvailableTimeSlots(dateWiseTimeSlots)

  // }

  const handleMonthChange = (action, activeStartDate, value, view) => {
    setBookingsVisibleMonthAnyDate(activeStartDate)
    if (
      (action === 'prev' && view === 'month') ||
      (action === 'prev2' && view === 'month') ||
      (action === 'next' && view === 'month') ||
      (action === 'next2' && view === 'month') ||
      (action === 'drillDown' && view === 'month')
    ) {
      console.log('month change')
      // setLastActiveStartDate(dayjs(activeStartDate)?.format("YYYY-MM-DD"));
      // const activeStartDateBasicFormat = dayjs(activeStartDate)?.format("YYYY-MM-DD");
      // setCalendarData(activeStartDateBasicFormat, selectedTimeZone, scheduleOfProfessional?.timeZone);
      // setSelectedDateValue(null)
    }
  } // handling month change

  const navigate = useNavigate()

  return (
    <BPEventCalendarParent>
      <StyledWebinarSelectTimeZone
        value={encodeURIComponent(selectedTimeZone)}
        onChange={(e) => setSelectedTimeZone(e.target.value)}
      >
        {getTimeZoneOptionsWithValueAsTimezoneOffset()}
      </StyledWebinarSelectTimeZone>
      <BPCalendarContainer>
        <Calendar
          onChange={onChangeDate}
          value={selectedDateValue}
          minDate={dateToday}
          maxDate={maxDate}
          minDetail="decade"
          tileDisabled={tileDisabled}
          showNeighboringMonth={false}
          onActiveStartDateChange={({ action, activeStartDate, value, view }) =>
            handleMonthChange(action, activeStartDate, value, view)
          }
        />
      </BPCalendarContainer>
      <BPCalendarSeparator />
      {/* {selectedDateValue &&
        availableWebinars
          ?.filter((webinar) =>
            checkIfTwoDatesAreEqual(webinar?.startTime, selectedDateValue, selectedTimeZone),
          )
          ?.map((webinar) => (
            <BPAvailableEventItem key={webinar?.id} onClick={() => selectAWebinarToBook(webinar)}>
              <BPAvailableEventSecondary>
                {dayjs(webinar?.startTime).utcOffset(selectedTimeZone).format('h A')}
              </BPAvailableEventSecondary>
              <div style={{ display: 'flex', justifyContent: 'flex-start', gap: '3px' }}>
                <BPCalendarDateHeading>{webinar.title}</BPCalendarDateHeading>
                <BPCalendarDateHeading>-</BPCalendarDateHeading>
                <BPAvailableEventHighlight>{webinar?.mentorName}</BPAvailableEventHighlight>
              </div>
            </BPAvailableEventItem>
          ))} */}
      <div
        style={{ fontWeight: '500', marginRight: 'auto', cursor: 'pointer' }}
        onClick={() => navigate('/workplace/webinars')}
      >
        <u>Book a webinar</u>
      </div>
    </BPEventCalendarParent>
  )
}

export function BusinessBookedEventsComponent({
  alreadyBookedWebinars,
  bookingsVisibleMonthAnyDate,
  selectedTimeZone,
}) {
  const [showBookedWebinarDialog, setShowBookedWebinarDialog] = useState(false)
  const [selectedWebinar, setSelectedWebinar] = useState({})

  function closeBookedWebinarDialog() {
    setShowBookedWebinarDialog(false)
  }

  function handleAssignClick(webinar) {
    setSelectedWebinar(webinar)
    setShowBookedWebinarDialog(true)
  }

  return (
    <BPBookedEventsParent>
      <BPBookedEventsHeading>
        {dayjs(bookingsVisibleMonthAnyDate)?.format('MMMM YYYY')} Bookings
      </BPBookedEventsHeading>
      <BPCalendarSeparator />
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {alreadyBookedWebinars
          ?.sort((a, b) => dayjs(a.startTime).diff(dayjs(b.startTime)))
          ?.map((webinar, idx) => {
            const presentMonth = dayjs(bookingsVisibleMonthAnyDate).month()
            const adjustedStartTime = dayjs(webinar?.startTime)
              .set('month', presentMonth)
              .utcOffset(selectedTimeZone)
            const isCompleted = adjustedStartTime.isBefore(dayjs())
            return (
              <div
                key={idx}
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'space-between',
                  borderBottom: '1px solid #E0E0E05F',
                  padding: '20px 10px',
                  width: '100%',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                    gap: '7px',
                    padding: '0px 20px 0px 0px',
                  }}
                >
                  <BPBookedEventItem style={{ padding: '0px' }}>
                    <BPAlreadyBookedEventSecondary>
                      {dayjs(webinar?.startTime)
                        .set('month', presentMonth)
                        .utcOffset(selectedTimeZone)
                        .format('D MMMM h:mm A')}
                    </BPAlreadyBookedEventSecondary>
                    <div style={{ display: 'flex', justifyContent: 'flex-start', gap: '3px' }}>
                      <BPAlreadyBookedEventHeading>
                        {webinar.title}{' '}
                        <span className="text-success">{isCompleted && '(Completed)'}</span>
                      </BPAlreadyBookedEventHeading>
                    </div>
                    <BPAlreadyBookedEventHighlight>
                      {webinar?.mentorName}
                    </BPAlreadyBookedEventHighlight>
                    {/* <BPAlreadyBookedEventSecondary>
                    Available Seats: {webinar?.maxUsers - webinar?.minUsers}
                  </BPAlreadyBookedEventSecondary>
                  <BPAlreadyBookedEventSecondary>
                    Attending Employees: 0
                  </BPAlreadyBookedEventSecondary> */}
                  </BPBookedEventItem>
                </div>
                {/* <div
                style={{
                  display: 'flex',
                  flexDirection: 'column-reverse',
                  alignItems: 'flex-end',
                  height: '100%',
                }}
              >
                <BPAlreadyBookedEventAssignButton onClick={() => handleAssignClick(webinar)}>
                  Assign
                </BPAlreadyBookedEventAssignButton>
              </div> */}
              </div>
            )
          })}
      </div>
      <Dialog
        open={showBookedWebinarDialog}
        PaperComponent={AddEmployeesDialogPaper}
        onClose={closeBookedWebinarDialog}
      >
        <AddEmployeesToWebinarDialog
          webinarDetails={selectedWebinar}
          closeDialog={closeBookedWebinarDialog}
        />
      </Dialog>
    </BPBookedEventsParent>
  )
}
